import { createContext, useContext } from "react";
import { SyncActionType, SyncStateType } from "./syncReducer";
type IContextProps = [SyncStateType, (action: SyncActionType) => void];

export const SyncContext = createContext([] as unknown as IContextProps);

export const useSyncContext = () => useContext(SyncContext);
